import { z } from 'zod';

export const RemainingStepsZod = z.union([z.literal('printed'), z.literal('signed'), z.literal('tfChecked')]);
export type RemainingSteps = z.infer<typeof RemainingStepsZod>;
